import axios from "axios";
import logoXD from "assets/images/small-logos/logo-xd.svg";
import { API_URL } from "config/api";

const endpoint = API_URL;

const getIngresosPorEmpresa = async (companyId) => {
  try {
    const [ventaResponse, empresaResponse, sucursalesResponse] = await Promise.all([
      axios.get(`${endpoint}/ventas`),
      axios.get(`${endpoint}/empresas`),
      axios.get(`${endpoint}/sucursales`),
    ]);

    const empresas = empresaResponse.data || [];
    const ventas = ventaResponse.data || [];
    const sucursales = sucursalesResponse.data || [];

    const labels = [];
    const chartData = [];

    if (companyId) {
      // Si hay un ID de empresa, mostrar ingresos por sucursal de esa empresa
      const sucursalesEmpresa = sucursales.filter((s) => String(s.empresa_id) === String(companyId));
      sucursalesEmpresa.forEach((sucursal) => {
        let total = 0;
        ventas.forEach((venta) => {
          if (venta.sucursal_id === sucursal.id) {
            total += parseFloat(venta.total) || 0;
          }
        });
        labels.push(sucursal.nombre || "Sucursal sin nombre");
        chartData.push(total);
      });
    } else {
      // Si no hay ID, mostrar ingresos por empresa (consolidado)
      empresas.forEach((empresa) => {
        let total = 0;
        // Obtener IDs de sucursales de esta empresa
        const sucursalesIds = sucursales
          .filter((s) => String(s.empresa_id) === String(empresa.id))
          .map((s) => s.id);

        ventas.forEach((venta) => {
          if (sucursalesIds.includes(venta.sucursal_id)) {
            total += parseFloat(venta.total) || 0;
          }
        });
        labels.push(empresa.nombre || "Sin Nombre");
        chartData.push(total);
      });
    }

    return {
      labels: labels,
      datasets: [{ label: "Ingresos", data: chartData }],
    };
  } catch (error) {
    console.error("Error fetching ingresos por empresa:", error);
    return {
      labels: [],
      datasets: [{ label: "Ingresos", data: [] }],
    };
  }
};

export default getIngresosPorEmpresa;
